/**
 * Import Dependency
 */
import { createStore, applyMiddleware, compose } from 'redux'
import thunk from 'redux-thunk'
import rootReducer from '../reducers'
import { loadState, saveState } from './localStorage'
import * as _ from 'lodash'
/**
 * Declare Variable
 */

const logger = store => next => action => {
  const result = next(action)
  console.info({
    type: 'dispatching',
    action,
    // state: store.getState(),
  })
  return result
}

const persistedState = loadState()
const middleware = [thunk, logger]

// Ignore redux-logger in Production
// if (process.env.NODE_ENV !== 'production') {
//     const { logger } = require('redux-logger');
//     middleware = [
//         ...middleware,
//         logger
//     ];
// }

const composeEnhancers =
  typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
      // Specify extension’s options like name, actionsBlacklist, actionsCreators, serialize...
    })
    : compose

const enhancer = composeEnhancers(
  applyMiddleware(...middleware),
  // other store enhancers if any
)

const store = createStore(
  rootReducer,
  {
    ...persistedState,
    basket: {
      ...persistedState.basket,
      isTakeawayAvailable: true,
      request: false
    },
    orders: (persistedState.orders || []).map(o => ({
      ...o,
      remarks: o.remarks || [],
    })),
  },
  enhancer,
)

/**
 * Config
 */
store.subscribe(() => {
  const state = store.getState()
  saveState(_.pick(state, [
    'query',
    'user',
    'basket',
    'orders',
    'locale',
    'userLocale',
    'packages',
    'promocodes',
    'form',
  ]))
})

/**
 * Export
 */
export default store



// WEBPACK FOOTER //
// ./src/store/index.js